import React from 'react';
import '../styles/Reports.css';
import {
  FileBarChart,
  ClipboardList,
  ShieldCheck,
  FileText,
  Users,
  CalendarCheck,
} from 'lucide-react';

const Reports = () => {
  return (
    <div className="reports-page">
      <header className="header">
        <h1>
          <FileBarChart size={28} style={{ marginRight: '10px', verticalAlign: 'middle' }} />
          Reports
        </h1>
        <p style={{ color: 'var(--text-secondary)' }}>Access and download compliance and daily reports.</p>
      </header>
      <section className="card-grid">
        <div className="card report-card">
          <div className="card-icon">
            <FileText size={24} />
          </div>
          <div className="card-content">
            <h3>Student Reports</h3>
            <p>Generate by age, progress, and attendance</p>
            <span className="badge info">NEW</span>
          </div>
        </div>

        <div className="card report-card">
          <div className="card-icon">
            <Users size={24} />
          </div>
          <div className="card-content">
            <h3>Teacher Reports</h3>
            <p>Track performance and schedules</p>
            <span className="badge warning">3 Pending</span>
          </div>
        </div>

        <div className="card report-card">
          <div className="card-icon">
            <CalendarCheck size={24} />
          </div>
          <div className="card-content">
            <h3>Attendance Logs</h3>
            <p>Export daily or monthly records</p>
            <span className="badge success">Up to Date</span>
          </div>
        </div>

        <div className="card report-card">
          <div className="card-icon">
            <ClipboardList size={24} />
          </div>
          <div className="card-content">
            <h3>Daily Summary</h3>
            <p>View today’s attendance and meals</p>
            <span className="badge info">Updated</span>
          </div>
        </div>

        <div className="card report-card">
          <div className="card-icon">
            <FileBarChart size={24} />
          </div>
          <div className="card-content">
            <h3>Incident Logs</h3>
            <p>All reported events</p>
            <span className="badge danger">3 Issues</span>
          </div>
        </div>

        <div className="card report-card">
          <div className="card-icon">
            <ShieldCheck size={24} />
          </div>
          <div className="card-content">
            <h3>Compliance</h3>
            <p>Last reviewed: 2 days ago</p>
            <span className="badge warning">Due Soon</span>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Reports;
